<template>
  <section class="top top_margin top_flex top_height">
    <div class="filters__wrapper" v-if="isMobile">
      <div class="filters__reset" v-show="isResetActive" @click="filtersReset">Сбросить</div>
      <div class="filters__title filters__title_mobile">Фильтры</div>
      <div class="filters__close" @click="closeModalMobile">Закрыть</div>
    </div>
    <nav class="filters">
      <div class="filters__title">Выкупы</div>
      <div v-if="isCross" @click="isCross = false" class="filters__back filters__header-icon">Назад</div>
      <ul class="filters__list">
        <Multiselect v-model="type" :options="deviceTypes" :allow-empty="false"
                     :class="{'filters__all-shops': shopName === 'Все магазины' || shopName !== 'Все магазины'}"
                     :showLabels="false"
                     :multiple="true" :searchable="false" :groupSelect="true"
                     :close-on-select="false"
                     :clear-on-select="false" :preserve-search="true"
                     label="name" track-by="name" @input="setDeviceTypeId(typeName)" @open="checkWrapperClass"  @close="checkWrapperClass">
          <template slot="beforeList" v-if="isMobile">
            <div class="filters__position">
              <div class="filters__title filters__title_position filters__title_mobile">Устройства</div>
            </div>
          </template>
          <template slot="selection" slot-scope="{ values }">
            <span class="multiselect__single">{{values.length > 1 ?  `Устройств: ${values.length}` : typeName }}</span>
          </template>
        </Multiselect>

        <Multiselect v-model="manufacturers" :options="manufacturersStore" :allow-empty="false"
                     :class="{'filters__all-shops': shopName === 'Все магазины' || shopName !== 'Все магазины'}"
                     :showLabels="false"
                     :multiple="true" :searchable="false" :groupSelect="true"
                     :close-on-select="false"
                     :clear-on-select="false" :preserve-search="true"
                     label="name" track-by="name" @input="setManufacturersId(manufacturersName)" @open="checkWrapperClass"  @close="checkWrapperClass">
          <template slot="beforeList" v-if="isMobile">
            <div class="filters__position">
              <div class="filters__title filters__title_position filters__title_mobile">Производители</div>
            </div>
          </template>
          <template slot="selection" slot-scope="{ values }">
            <span class="multiselect__single">{{values.length > 1 ?  `Производителей: ${values.length}` : manufacturersName }}</span>
          </template>
        </Multiselect>

        <Multiselect v-model="grade" :options="gradeList" :allow-empty="false"
                     :class="{'filters__all-shops': shopName === 'Все магазины' || shopName !== 'Все магазины'}"
                     :showLabels="false"
                     :multiple="true" :searchable="false" :groupSelect="true"
                     :close-on-select="false"
                     :clear-on-select="false" :preserve-search="true"
                     label="name" track-by="name" @input="setGrade(gradeName)" @open="checkWrapperClass"  @close="checkWrapperClass">
          <template slot="beforeList" v-if="isMobile">
            <div class="filters__position">
              <div class="filters__title filters__title_position filters__title_mobile">Грейды</div>
            </div>
          </template>
          <template slot="selection" slot-scope="{ values }">
            <span class="multiselect__single">{{values.length > 1 ?  `Грейдов: ${values.length}` : gradeName }}</span>
          </template>
        </Multiselect>



        <nav class="filters__nav filters__time" :class="{'filters__time_rotate': isOpenMenuShop}" v-click-outside="closeMenuShop">
          <div class="filters__nav-wrapper-name" @click="openShopModal">
            <span class="filters__nav-name">{{cityShopTitle}}</span>
          </div>
          <ul class="filters__menu filters__menu_height" :class="{'filters__menu_active': isOpenMenuShop}">
            <div class="filters__tabs">
              <div ref="filterShop" class="filters__tab" :class="{'filters__tab_active': currentActiveTab === 'Магазины'}"
                   @click="selectShop($event.target.innerText)">Магазины
              </div>
              <div class="filters__tab" :class="{'filters__tab_active': currentActiveTab === 'Города'}"
                   @click="selectShop($event.target.innerText)">Города
              </div>
              <div class="filters__tab" :class="{'filters__tab_active': currentActiveTab === 'Кусты'}"
                   @click="selectShop($event.target.innerText)">Кусты
              </div>
            </div>

            <div class="filters__nav-shops" v-if="currentActiveTab === 'Магазины'">
              <Multiselect v-model="shop" :options="activeTab" :allow-empty="false"
                           :showLabels="false"
                           :class="{'filters__all-shops': shopName === 'Все магазины' || shopName !== 'Все магазины'}"
                           :multiple="true" :searchable="false" :groupSelect="true"
                           :close-on-select="false"
                           :clear-on-select="false" :preserve-search="true"
                           label="name" track-by="name"
                           @input="setStoreId(shopName)">

                <template slot="selection" slot-scope="{ values }">
                  <span class="multiselect__single">{{values.length > 1 ?  `магазинов: ${values.length}` : shopName }}</span>
                </template>
                <span slot="noOptions"></span>
              </Multiselect>
            </div>

            <div class="filters__nav-city" v-if="currentActiveTab === 'Города'">
              <Multiselect v-model="city" :options="activeCitiesTab" :allow-empty="false"
                           :showLabels="false"
                           :class="{'filters__all-shops': shopName === 'Все магазины' || shopName !== 'Все магазины'}"
                           :multiple="true" :searchable="false" :groupSelect="true"
                           :close-on-select="false"
                           :clear-on-select="false" :preserve-search="true"
                           label="name" track-by="name" @open="checkWrapperClass"  @close="checkWrapperClass"
                           @input="setCity(cityName)">

                <template slot="selection" slot-scope="{ values }">
                  <span class="multiselect__single">{{values.length > 1 ?  `Городов: ${values.length}` : cityName }}</span>
                </template>
                <span slot="noOptions"></span>
              </Multiselect>
            </div>

            <div v-if="currentActiveTab === 'Кусты'">
              <div v-if="isActiveRegions" class="filters__regions">
                <div class="filters__regions-img">
                  <img src="../assets/images/not-found-icon.svg" alt="">
                </div>
                <div class="filters__regions-title">Пока нет ни одного Куста</div>
                <div class="filters__regions-text">Чтобы добавить данные по кустам, городам и регионам вам
                  необходимо сделать запрос в поддержку и приложить
                  <span class="filters__regions-mark">CSV</span>
                  <span>
										<a class="filters__regions-link filters__regions-link_border" href="#">заполненный Excel</a>
									</span>
                  с вашими данными.
                </div>
                <a href="#" class="filters__regions-link filters__regions-link_block filters__regions-link_center">Написать в поддержку</a>
              </div>
            </div>
          </ul>
        </nav>



        <nav class="filters__nav filters__time" :class="{'filters__time_rotate': isOpenMenu}" v-click-outside="closeMenu">
          <div class="filters__nav-wrapper-name" @click="openTimeModal">
            <span ref="filterNav" class="filters__nav-name">Все время</span>
          </div>
          <ul class="filters__menu" :class="{'filters__menu_active': isOpenMenu}">
            <div class="filters__position">
              <div class="filters__title filters__title_margin filters__title_position filters__title_mobile">Время</div>
            </div>
            <li class="filters__item filters__item_padding-left"
                :class="{'filters__item_active': currentActiveMenu === 'Все время'}"
                @click="selectItem($event.target.innerText)">Все время
            </li>
            <li class="filters__item filters__item_padding-left"
                :class="{'filters__item_active': currentActiveMenu === 'Текущую неделю'}"
                @click="selectItem($event.target.innerText)">Текущую неделю
            </li>
            <li class="filters__item filters__item_padding-left"
                :class="{'filters__item_active': currentActiveMenu === 'Текущий месяц'}"
                @click="selectItem($event.target.innerText)">Текущий месяц
            </li>
            <li class="filters__item filters__item_padding-left"
                :class="{'filters__item_active': currentActiveMenu === 'Текущий квартал'}"
                @click="selectItem($event.target.innerText)">Текущий квартал
            </li>
            <li class="filters__item" @click="selectItem($event.target.innerText)"
                :class="{'filters__item_active-data': currentActiveMenu === 'Дату'}">
              <VueCtkDateTimePicker id="1" :right="true" label="Дату" v-model="singleDate"
                                    output-format="YYYY-MM-DD" format="YYYY-MM-DD" formatted="DD.MM.YYYY"
                                    :only-date="true"
                                    :auto-close="true" :no-header="true" :no-shortcuts="true"
                                    :no-button="true" @input="changeDatapicker(singleDate)"/>
            </li>
            <li class="filters__item" @click="selectItem($event.target.innerText)"
                :class="{'filters__item_active-data': currentActiveMenu === 'Период'}">
              <VueCtkDateTimePicker id="2" :right="true" label="Период" v-model="datepickerValue"
                                    output-format="YYYY-MM-DD" format="YYYY-MM-DD" formatted="DD.MM.YYYY"
                                    :only-date="true"
                                    :auto-close="true" :no-header="true" :no-shortcuts="true"
                                    :no-button="true" :range="true"
                                    @input="changeDatapicker(getFullDate)"/>
            </li>
          </ul>
        </nav>
      </ul>
    </nav>
    <div class="filters__reset" v-show="isResetActive && !isMobile" @click="filtersReset">Сбросить</div>
    <a class="filters__link" @click="downloadExcel" href="#">Скачать в Excel</a>
  </section>

</template>
<script>
  import Multiselect from 'vue-multiselect';
  import ClickOutside from 'vue-click-outside';
  import moment from 'moment';
  import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
  import {mapActions, mapMutations, mapState} from 'vuex';

  export default {
    name: 'TheFilters',

    data: () => ({
      cityShopTitle: 'Все магазины',
      isMobile: false,
      isResetActive: false,
      isOpenMenu: false,
      isOpenMenuShop: false,
      activeTab: [],
      activeCitiesTab: [],
      isActiveRegions: false,
      currentActiveMenu: 'Все время',
      currentActiveTab: 'Магазины',
      singleDate: '',
      datepickerValue: {
        key: 'customValue',
        value: () => ({
          start: '2020-01-01',
          end: `2020-${new Date().getMonth() + 1}-30}`
        })
      },
      grade: [{'id': 0, 'name': 'Все грейды', 'selector': 'grade'}],
      gradeList: [
        {id: 0, name: 'Все грейды', 'selector': 'grade'},
        {id: 1, name: 'Грейд А',  'selector': 'grade'},
        {id: 2, name: 'Грейд Б',  'selector': 'grade'},
        {id: 3, name: 'Грейд С',  'selector': 'grade'},
        {id: 4, name: 'Грейд Д' , 'selector': 'grade'}
      ],
      type: [{'id': 0, 'name': 'Все типы', 'selector': 'deviceType'}],
      city: [{'id': 0, 'name': 'Все города', 'selector': 'cities'}],
      manufacturers: [{'id': 0, 'name': 'Все производители', 'selector': 'manufacturer'}],
      shop: [{'id': 0, 'name': 'Все магазины', 'selector': 'store'}],
      gradeArray: [],
      isCross: false
    }),
    components: {
      Multiselect,
      VueCtkDateTimePicker
    },
    computed: {
      ...mapState(['deviceTypes', 'manufacturersStore', 'shops', 'cities', 'selectedFilters', 'otherManufacturerId', 'gradeA', 'gradeB', 'gradeC', 'gradeD']),

      cityName() {
        let name;
        this.city.map(element => {
          name = element.name;
        });
        return name;
      },
      cityId() {
        let cityMass = [];
        this.city.map(shop => {
          cityMass.push(shop.id);
        });
        return cityMass;
      },
      gradeName() {
        let name;
        this.grade.map(element => {
          name = element.name;
        });
        return name;
      },
      typeName() {
        let name;
        this.type.map(element => {
          name = element.name;
        });
        return name;
      },
      shopName() {
        let name;
        this.shop.map(element => {
          name = element.name;
        });
        return name;
      },
      manufacturersName() {
        let name;
        this.manufacturers.map(element => {
          name = element.name;
        });
        return name;
      },

      deviceTypeId() {
        let deviceMass = [];
        this.type.map(type => {
          deviceMass.push(type.id);
        });
        return deviceMass;
      },
      manufacturerId() {
        let manufacturersMass = [];
        this.manufacturers.map(manufacture => {
          manufacturersMass.push(manufacture.id);
        });
        return manufacturersMass;
      },
      storeId() {
        let storeMass = [];
        this.shop.map(shop => {
          storeMass.push(shop.id);
        });
        return storeMass;
      },
      getFullDate() {
        let fullDateArray = [];
        fullDateArray.push(moment(this.datepickerValue.start).format('YYYY-MM-DD'), moment(this.datepickerValue.end).format('YYYY-MM-DD'));
        return fullDateArray;
      },
    },
    methods: {
      ...mapActions(['GET_INFO_FILTER', 'SET_FILTER_VALUE', 'GET_EXCEL', 'SET_OTHER_MANUFACTURER']),
      ...mapMutations(['addDeviceTypeId', 'addStoreId', 'setCities', 'addManufacturerId', 'setDatapicker', 'GET_GRADE']),

      closeModalMobile() {
        this.$emit('close');
      },
      openShopModal() {
        this.$refs.filterShop.click();
        this.selectShop('Магазины');
        this.checkWrapperClass();
        this.isOpenMenuShop = !this.isOpenMenuShop;
      },
      openTimeModal() {
        this.checkWrapperClass();
        this.isOpenMenu = !this.isOpenMenu
      },
      checkWrapperClass() {
        this.isCross = !this.isCross;
      },
      setGrade(value) {
        if (value !== 'Все грейды') {
          this.isResetActive = true;

          this.grade = this.grade.filter(element => {
            return element.name !== 'Все грейды';
          });
        } else {
          this.grade = [{'id': 0, 'name': 'Все грейды', 'selector': 'grade'}];
          if(this.type[0].name === 'Все типы' && this.manufacturers[0].name === 'Все производители' && this.shop[0].name === 'Все магазины' && this.currentActiveMenu === 'Все время') {
            this.isResetActive = false;
          }
        }

        this.gradeArray = [];
        this.grade.map(grade => {
          if(grade.name === 'Грейд А') {
            this.gradeArray = this.gradeArray.concat(this.gradeA);
          }

          if(grade.name === 'Грейд Б') {
            this.gradeArray = this.gradeArray.concat(this.gradeB);
          }

          if(grade.name === 'Грейд С') {
            this.gradeArray = this.gradeArray.concat(this.gradeC);
          }
          if(grade.name === 'Грейд Д') {
            this.gradeArray = this.gradeArray.concat(this.gradeD);
          }
        });

        this.GET_GRADE(this.gradeArray);
        this.SET_FILTER_VALUE();
      },

      closeMenu() {
        this.isOpenMenu = false;
      },
      closeMenuShop() {
        this.isOpenMenuShop = false;
      },

      filtersReset() {
        this.setDeviceTypeId('Все типы');
        this.setManufacturersId('Все производители');
        this.setStoreId('Все магазины');
        this.selectItem('Все время');
        this.setGrade('Все грейды');
        this.setCity('Все города');
        this.SET_FILTER_VALUE();
      },

      selectItem(event) {

        switch (event) {
          case 'Период':
            this.currentActiveMenu = 'Период';
            break;
          case 'Текущую неделю':
            this.currentActiveMenu = 'Текущую неделю';
            this.getCurrentWeek();
            this.$refs.filterNav.innerText = 'Текущую неделю';
            this.isOpenMenu = false;
            break;
          case 'Текущий месяц':
            this.currentActiveMenu = 'Текущий месяц';
            this.getCurrentMounth();
            this.$refs.filterNav.innerText = 'Текущий месяц';
            this.isOpenMenu = false;
            break;
          case 'Текущий квартал':
            this.currentActiveMenu = 'Текущий квартал';
            this.getCurrentQuarter();
            this.$refs.filterNav.innerText = 'Текущий квартал';
            this.isOpenMenu = false;
            break;
          case 'Дату':
            this.currentActiveMenu = 'Дату';
            break;
          case 'Все время':
            if(this.manufacturers[0].name === 'Все производители' && this.grade[0].name === 'Все грейды' && this.type[0].name === 'Все типы' && this.shop[0].name === 'Все магазины') {
              this.isResetActive = false;
            }
            this.currentActiveMenu = 'Все время';
            this.changeDatapicker([]);
            this.$refs.filterNav.innerText = 'Все время';
            break;
        }

        if (event !== 'Все время') {
          this.isResetActive = true;
        }
      },

      selectShop(value) {
        if (value === 'Магазины') {
          this.isActiveRegions = false;
          this.currentActiveTab = 'Магазины';
          const shopsTitle = function() {
            document.querySelectorAll('.multiselect__single').forEach(element => {
              if(element.innerText === 'Все магазины') {
                let wrapperElement = element.closest('.multiselect').querySelector('.multiselect__content-wrapper');
                document.querySelectorAll('.multiselect__content-wrapper').forEach(target => {
                  target.style.display = 'none';
                })
                wrapperElement.style.display = 'block';
              }
            });
          }

          setTimeout(() => {
            shopsTitle();
          }, 0)
        } else if (value === 'Города') {
          this.isActiveRegions = true;
          this.currentActiveTab = 'Города';

          const shopsTitle = function() {
            document.querySelectorAll('.multiselect__single').forEach(element => {
              if(element.innerText === 'Все города') {
                let wrapperElement = element.closest('.multiselect').querySelector('.multiselect__content-wrapper');
                document.querySelectorAll('.multiselect__content-wrapper').forEach(target => {
                  target.style.display = 'none';
                })
                wrapperElement.style.display = 'block';
              }
            });
          }

          setTimeout(() => {
            shopsTitle();
          }, 0)
        } else if (value === 'Кусты') {
          this.isActiveRegions = true;
          this.currentActiveTab = 'Кусты';
        }
      },

      downloadExcel() {
        this.GET_EXCEL();
      },

      getCurrentWeek() {
        const currentDate = moment();

        const weekStart = currentDate.clone().startOf('isoWeek');
        let days = [];
        let datepickerWeek = [];

        for (let i = 0; i <= 6; i++) {
          days.push(moment(weekStart).add(i, 'days').format('YYYY-MM-DD'));
        }
        datepickerWeek.push(days[0], days[6]);
        this.changeDatapicker(datepickerWeek);
      },

      getCurrentMounth() {
        let currentMounthArray = [];
        const date = new Date(), y = date.getFullYear(), m = date.getMonth();
        const setFirstDayOfMounth = new Date(y, m, 1);
        const setLastDayOfMounth = new Date(y, m + 1, 0);
        const fistDayOfMounth = moment(setFirstDayOfMounth).format('YYYY-MM-DD');
        const lastDayOfMounth = moment(setLastDayOfMounth).format('YYYY-MM-DD');
        currentMounthArray.push(fistDayOfMounth, lastDayOfMounth);
        this.changeDatapicker(currentMounthArray);
      },

      getCurrentQuarter() {
        const today = new Date();
        const month = today.getMonth();
        let from;
        let to;
        let currentQuarterArray = [];
        if (month < 4) {
          // Квартрал 1 с Января по Март;
          from = `${today.getFullYear()}-01-01`;
          to = `${today.getFullYear()}-03-31`;
        } else if (month < 7) {
          // Квартрал 2 с Апреля по Июнь;
          from = `${today.getFullYear()}-04-01`;
          to = `${today.getFullYear()}-06-30`;
        } else if (month < 10) {
          // Квартрал 3 с Июля по Сентябрь;
          from = `${today.getFullYear()}-07-01`;
          to = `${today.getFullYear()}-09-30`;
        } else if (month < 13) {
          // Квартрал 4 с Июля по Сентябрь;
          from = `${today.getFullYear()}-10-01`;
          to = `${today.getFullYear()}-12-31`;
        }
        currentQuarterArray.push(from, to);
        this.changeDatapicker(currentQuarterArray);
      },

      changeDatapicker(datepicker) {
        let datePickerArrayView;
        if (typeof datepicker === 'object') {
          if (datepicker[1] !== 'Invalid date') {
            this.$nextTick(() => this.setDatapicker(datepicker), 500);
            this.$nextTick(() => this.SET_FILTER_VALUE(), 1000);

            datePickerArrayView = [];
            datepicker.map(date => {
              let result = date.replace(/[- .]/g, '.');
              datePickerArrayView.push(moment(result, 'YYYY.MM.DD').format('DD.MM.YYYY'));
              this.$refs.filterNav.innerText = datePickerArrayView;
            });
            this.isOpenMenu = false;
          }
        } else {
          this.$nextTick(() => this.setDatapicker(datepicker), 500);
          this.$nextTick(() => this.SET_FILTER_VALUE(), 1000);
          this.$refs.filterNav.innerText = moment(datepicker).format('DD.MM.YYYY');
          this.isOpenMenu = false;
        }
        this.$refs.filterNav.innerText = this.$refs.filterNav.innerText.replace(/[,]/g, ' - ');

        this.isCross = false;
      },
      setDeviceTypeId(value) {

        if (value !== 'Все типы') {
          this.isResetActive = true;

          this.type = this.type.filter(element => {
            return element.name !== 'Все типы';
          });
        } else {
          this.type = [{'id': 0, 'name': 'Все типы', 'selector': 'deviceType'}];

          if(this.manufacturers[0].name === 'Все производители' && this.grade[0].name === 'Все грейды' && this.shop[0].name === 'Все магазины' && this.currentActiveMenu === 'Все время') {
            this.isResetActive = false;
          }
        }

        if (this.deviceTypeId) {
          this.$nextTick(() => this.addDeviceTypeId(this.deviceTypeId), 500);
        }
        this.$nextTick(() => this.SET_FILTER_VALUE(), 1000);

      },
      setManufacturersId(value) {
        if (value !== 'Все производители') {
          this.isResetActive = true;

          this.manufacturers = this.manufacturers.filter(element => {
            return element.name !== 'Все производители';
          });
        } else {
          if(this.type[0].name === 'Все типы' && this.grade[0].name === 'Все грейды' && this.shop[0].name === 'Все магазины' && this.currentActiveMenu === 'Все время') {
            this.isResetActive = false;
          }
          this.manufacturers = [{'id': 0, 'name': 'Все производители', 'selector': 'manufacturer'}];
        }

        if (this.manufacturerId) {
          if (value === 'Другие') {
            let resultOtherArray = this.manufacturerId.concat(this.otherManufacturerId).filter(function (x) {
              return x !== undefined && x !== null;
            });
            this.$nextTick(() => this.addManufacturerId(resultOtherArray), 500);
          } else {
            let resultArray = this.manufacturerId.filter(function (x) {
              return x !== undefined && x !== null;
            });
            this.$nextTick(() => this.addManufacturerId(resultArray), 500);
          }
        }
        this.$nextTick(() => this.SET_FILTER_VALUE(), 1000);
      },
      setCity(value, reset) {
        if(reset) {
          this.city = [{id: 0, name: 'Все города', selector: 'cities'}];
          this.$nextTick(() => this.setCities(), 500);
          this.$nextTick(() => this.SET_FILTER_VALUE(), 1000);
          return false;
        }
        if (value !== 'Все города') {
          this.isResetActive = true;

          this.city = this.city.filter(element => {
            return element.name !== 'Все города';
          });

          if (this.cityId) {
            if(this.cityId.length > 1) {
              this.cityShopTitle = 'Городов: ' + this.cityId.length;
            } else if ((this.cityId.length === 1)) {
              this.cityShopTitle = this.cityName;
            }
          }
          this.$nextTick(() => this.setCities(this.cityId), 500);
          this.setStoreId('Все магазины', true);

        } else {
          if(this.manufacturers[0].name === 'Все производители' && this.grade[0].name === 'Все грейды' && this.type[0].name === 'Все типы' && this.currentActiveMenu === 'Все время') {
            this.isResetActive = false;
          }
          this.cityShopTitle = 'Все города';
          this.city = [{id: 0, name: 'Все города', selector: 'cities'}];

          this.$nextTick(() => this.setCities(), 500);
        }
        this.$nextTick(() => this.SET_FILTER_VALUE(), 1000);
      },
      setStoreId(value, reset) {
        if(reset) {
          this.shop = [{'id': 0, 'name': 'Все магазины', 'selector': 'store'}];
          this.$nextTick(() => this.addStoreId(this.storeId), 500);
          this.$nextTick(() => this.SET_FILTER_VALUE(), 1000);
          return false;
        }

        if (value !== 'Все магазины') {
          this.isResetActive = true;

          this.shop = this.shop.filter(element => {
            return element.name !== 'Все магазины';
          });

          if (this.storeId) {
            if(this.storeId.length > 1) {
              this.cityShopTitle = 'Магазинов: ' + this.storeId.length;
            } else if ((this.storeId.length === 1)) {
              this.cityShopTitle = this.shopName;
            }
            this.$nextTick(() => this.addStoreId(this.storeId), 500);
          }
          this.setCity('Все города', true);

        } else {
          if(this.manufacturers[0].name === 'Все производители' && this.grade[0].name === 'Все грейды' && this.type[0].name === 'Все типы' && this.currentActiveMenu === 'Все время') {
            this.isResetActive = false;
          }
          this.cityShopTitle = 'Все магазины';
          this.shop = [{'id': 0, 'name': 'Все магазины', 'selector': 'store'}];
        }
        this.$nextTick(() => this.addStoreId(this.storeId), 500);
        this.$nextTick(() => this.SET_FILTER_VALUE(), 1000);
      },

    },
    directives: {
      ClickOutside
    },
    mounted() {
      this.GET_INFO_FILTER()
        .then(() => this.SET_FILTER_VALUE())
        .then(() => this.SET_OTHER_MANUFACTURER()
          .then(() => this.GET_GRADE(["gradeA", "gradeB", "gradeC", "gradeD"]))
          .then(() => this.setGrade('Все грейды')));
      this.addDeviceTypeId();
      setTimeout(() => this.activeTab = this.shops, 1000);
      setTimeout(() => this.activeCitiesTab = this.cities, 1000);

      window.addEventListener('resize', () => {
        this.isMobile = window.screen.width < 768;
      })

      this.isMobile = window.screen.width < 768;
    },

  };
</script>
<link rel="stylesheet" href="https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css">
